import {
  type ColumnType,
  type Selectable,
  type Insertable,
  type Updateable,
} from 'kysely'
import { z } from 'zod'

/** Identifier type for public.sensor_measurement_kind_ */
export type SensorMeasurementKindId = string & {
  __brand: 'SensorMeasurementKindId'
}

/** Represents the table public.sensor_measurement_kind_ */
export default interface SensorMeasurementKindTable {
  /** Database type: pg_catalog.text */
  id: ColumnType<
    SensorMeasurementKindId,
    SensorMeasurementKindId,
    SensorMeasurementKindId
  >

  /** Database type: pg_catalog.text */
  description: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.text */
  defaultUnit: ColumnType<string, string, string>

  /** Database type: pg_catalog.text */
  category: ColumnType<string | null, string | null, string | null>

  /** Database type: pg_catalog.timestamptz */
  createdAt: ColumnType<Date, Date | string | undefined, Date | string>
}

export type SensorMeasurementKind = Selectable<SensorMeasurementKindTable>

export type SensorMeasurementKindInitializer =
  Insertable<SensorMeasurementKindTable>

export type SensorMeasurementKindMutator =
  Updateable<SensorMeasurementKindTable>

export const sensorMeasurementKindId =
  z.string() as unknown as z.Schema<SensorMeasurementKindId>

export const sensorMeasurementKind = z.object({
  id: sensorMeasurementKindId,
  description: z.string().nullable().optional(),
  defaultUnit: z.string(),
  category: z.string().nullable().optional(),
  createdAt: z.coerce.date(),
}) as unknown as z.Schema<SensorMeasurementKind>

export const sensorMeasurementKindInitializer = z.object({
  id: sensorMeasurementKindId,
  description: z.string().optional().nullable(),
  defaultUnit: z.string(),
  category: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SensorMeasurementKindInitializer>

export const sensorMeasurementKindMutator = z.object({
  id: sensorMeasurementKindId.optional(),
  description: z.string().optional().nullable(),
  defaultUnit: z.string().optional(),
  category: z.string().optional().nullable(),
  createdAt: z.coerce.date().optional(),
}) as unknown as z.Schema<SensorMeasurementKindMutator>
